import React, { useState } from 'react';
import { ChakraProvider, Flex } from '@chakra-ui/react';
import ParentArea from '../../components/utils/ParentsArea';
import NumericKeypad from '../../components/Parents/NumericKeyboard';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

function Parents() {
    const [birthYear, setBirthYear] = useState('');
    const user = useSelector((state) => state.auth.user);
    const Navigate = useNavigate();

    const handleInput = (num) => {
      if (birthYear.length < 4) {
        setBirthYear(prev => prev + num);
      }
    };
  
    const handleDelete = () => { 
      setBirthYear(prev => prev.slice(0, -1)); 
    };

    const handleSubmit = () => {
      // if (user.fechaNacimiento === birthYear) {

      // }

      if (birthYear.length === 4) {
        Navigate('/Dashboard')
      }
    };
  
    return (
      <ChakraProvider>
        <Flex height="100vh" align="center" justify="center">
          <Flex direction="column" m="75px" align="center"> {/* Alinea los elementos al centro */}
            <ParentArea birthYear={birthYear} />
          </Flex>
          <Flex direction="column" m="75px" align="center"> {/* Alinea los elementos al centro */}
            <NumericKeypad onInput={handleInput} onDelete={handleDelete} onSubmit={handleSubmit} />
          </Flex>
        </Flex>
      </ChakraProvider>
    );
}

export default Parents;
